import { useTranslation } from 'react-i18next'

import Button from '@/components/Button/Button'

import styles from './FormFooter.module.scss'

type FormFooterProps = {
  isSubmitButtonDisabled?: boolean
}

const FormFooter = (props: FormFooterProps) => {
  const { t } = useTranslation('common')

  return (
    <footer className={styles.footer}>
      <Button asLink to="/absences" variant="secondary">
        {t('button.cancel')}
      </Button>
      <Button type="submit" disabled={props.isSubmitButtonDisabled}>
        {t('button.save')}
      </Button>
    </footer>
  )
}

export default FormFooter
